/**
 * websocket 域名
 * @description 集中控制websocket配置中socketHost的值，new WebSocket('ws://'+ socketHost +'/wsapp/');
 *				默认是线上雷测试环境的值
 *              isRain块内是线上雨课堂环境的值
 */

let socketHost = 'b.xuetangx.com'

if (process.env.SOCKET_HOST === 'isRain') {
    socketHost = 'rain.xuetangx.com'
}

export default socketHost



// WEBPACK FOOTER //
// ./src/util/socket-host.js